import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useChatActions, useChatConfig, useChatState } from './ChatProvider';
import { ChatLauncher } from './ChatLauncher';
import { ChatPanel } from './ChatPanel';
import { useIsMobile } from '@/hooks/useMediaQuery';
import { usePresence } from '@/hooks/usePresence';
/**
 * Embedded presentation: floating launcher + panel.
 * Desktop docks a 400px panel above the launcher; phones open a full-screen
 * sheet with a backdrop, which is the pattern Fin/Intercom use.
 */
export function ChatWidget() {
    const { launcher } = useChatConfig();
    const { close } = useChatActions();
    const isOpen = useChatState((s) => s.isOpen);
    const isMobile = useIsMobile();
    // Keeps the panel in the tree while it animates out.
    const { mounted, state } = usePresence(isOpen, 240);
    const mode = isMobile ? 'sheet' : 'panel';
    const hideLauncher = isMobile && mounted;
    return (_jsxs("div", { className: "ac-widget-root", style: { '--ac-offset': `${launcher.offset}px` }, children: [mounted && isMobile && (_jsx("div", { className: "ac-backdrop", "data-state": state, onClick: close, "aria-hidden": "true" })), mounted && _jsx(ChatPanel, { mode: mode, onClose: close, state: state }), !hideLauncher && _jsx(ChatLauncher, {})] }));
}
